export default {
  methods: {
    generateCheckboxId(type, val) {
      return this._uid + '-' + type + '-checkbox-' + val;
    },

    createErrorList(arr)
    {
      var list = document.createElement('div');
      for (var i = 0; i < arr.length; i++) {
        var item = document.createElement('div');
        item.appendChild(document.createTextNode(arr[i]));
        item.appendChild(document.createElement('br'));
        list.appendChild(item);
      }
      return list;
    },

    notifyErrors(e, message='Something went wrong') {
      var errorsAsArray = this.getErrorsAsArray(e);
      var errorList = this.createErrorList(errorsAsArray);
      swal({
        icon: 'warning',
        title: message,
        content: errorList
      });
    },

    getErrorsAsArray(e) {
      var errors;
      if (typeof e.response.data === 'object') {
        errors = _.flatten(_.toArray(e.response.data.errors));
      } else {
        errors = ['Something went wrong. Please try again.'];
      }
      return errors;
    },

    setErrors(e) {
      this.serverErrors = this.getErrorsAsArray(e);
    },

    getMentionIdsFromHtml(html) {
      let mentions = html.match(/data-mention-id="(.*?)"/g);
      return _.map(mentions, mention => {
        return mention.replace('data-mention-id=', '').replaceAll('"', '');
      });
    }
  }
}
